import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchCollection, getVal } from '../lib/api';

export default function Priser() {
  const [pageData, setPageData] = useState(null);
  const [machines, setMachines] = useState([]);
  const [pricesList, setPricesList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('alle');
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    async function loadData() {
      try {
        const [pageRes, machinesRes, pricesRes] = await Promise.all([
          fetchCollection('sider', { term: 'sidetype:priser' }),
          fetchCollection('maskiner', { limit: 100 }),
          fetchCollection('priser_og_pakker', { limit: 100 }),
        ]);

        if (pageRes.items && pageRes.items.length > 0) {
          setPageData(pageRes.items[0]);
        }
        setMachines(machinesRes.items || []);
        setPricesList(pricesRes.items || []);
      } catch (err) {
        console.error('Fejl ved indlæsning af prisliste fra CMS:', err);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  // Static items requested by the user that are not in the CMS
  const staticItems = [
    {
      id: 'static-glas',
      name: 'Glas',
      price: '3 kr. stk.',
      category: 'festudstyr',
      link: '/udlejning/glas',
      description: 'Fine glas til festen',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/fest-glas.jpg'
    },
    {
      id: 'static-sugeroer',
      name: 'Sugerør med ske',
      price: '3 kr. stk.',
      category: 'festudstyr',
      link: '/udlejning/sugeroer-med-ske',
      description: 'Perfekt til slushice',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/sugeroer-ske.jpg'
    },
    {
      id: 'static-popcorn-baeger',
      name: 'Popcorn bæger',
      price: '3 kr. stk.',
      category: 'festudstyr',
      link: '/udlejning/popcorn-maskine',
      description: 'Klassiske popcornbægre',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image8.jpeg'
    },
    {
      id: 'static-popcorn-mix',
      name: 'Popcorn mix',
      price: '375 kr.',
      category: 'festudstyr',
      link: '/udlejning/popcorn-maskine',
      description: 'Komplet mix med majs, salt og kokosolie',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image5_2.jpeg'
    },
    {
      id: 'static-saft-slushice',
      name: 'Saft til slushice',
      price: '90 kr.',
      category: 'festudstyr',
      link: '/udlejning/slushice-maskine',
      description: 'Flere lækre smagsvarianter',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/slushice.webp'
    },
    {
      id: 'static-koeleskab-glas',
      name: 'Køleskab med glaslåge',
      price: '300 kr.',
      category: 'koel-varme',
      link: '/udlejning/koeleskab-med-glaslaage',
      description: 'Professionelt flaskekøleskab',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/flaskekoeleskab.jpg'
    },
    {
      id: 'static-koeleskab-alm',
      name: 'Almindeligt køleskab',
      price: '150 kr.',
      category: 'koel-varme',
      link: '/udlejning/almindeligt-koeleskab',
      description: 'Rummeligt køleskab til mad og drikke',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/alm-koeleskab.jpg'
    },
    {
      id: 'static-lille-fryser',
      name: 'Lille fryser',
      price: '100 kr.',
      category: 'koel-varme',
      link: '/udlejning/lille-fryser',
      description: 'Perfekt til isterninger eller slushice-koncentrat',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image14.jpeg'
    },
    {
      id: 'static-fine-stole',
      name: 'Fine stole',
      price: '23 kr. pr. stk.',
      category: 'borde-stole',
      link: '/telt-udlejning/stole',
      description: 'Elegante stole til bryllup eller konfirmation',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/stol.png'
    },
    {
      id: 'static-cafe-bord',
      name: 'Cafebord',
      price: '50 kr.',
      category: 'borde-stole',
      link: '/telt-udlejning/cafebord',
      description: 'Højt ståbord / cafebord',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image29.jpeg'
    },
    {
      id: 'static-varme-ovn',
      name: 'Varmeovn (Gas)',
      price: '50 kr. uden gas',
      category: 'koel-varme',
      link: '/udlejning/varmeovn-gas',
      description: 'Effektiv opvarmning til teltet',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image0.jpeg'
    },
    {
      id: 'static-varme-kanon',
      name: 'Varmekanon (Gas)',
      price: '100 kr. uden gas',
      category: 'koel-varme',
      link: '/udlejning/varmekanon-gas',
      description: 'Kraftig varmekanon til hurtig opvarmning',
      coverImage: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image1_3.jpeg'
    }
  ];

  // Map CMS items to a unified format
  const mappedCmsItems = machines
    .filter(item => {
      const name = getVal(item.name).toLowerCase();
      return !['motorbør med bælter', 'minigraver 1.8 ton', 'benzindrevet jordfræser', 'pladevibrator 90 kg', 'brenderup maskintrailer'].includes(name);
    })
    .map(item => {
    const name = getVal(item.name);
    const price = getVal(item.price);
    
    // Determine category group
    const cmsCat = item.terms?.category?.[0] || '';
    let category = 'maskiner'; // default to construction machines
    
    if (['festudstyr', 'hoppeborg'].includes(cmsCat)) {
      category = 'festudstyr';
    } else if (['borde-og-stole'].includes(cmsCat)) {
      category = 'borde-stole';
    } else if (['telte'].includes(cmsCat)) {
      category = 'telte';
    }

    // Determine details link
    let link = `/maskiner/${item.id}`;
    if (name.toLowerCase().includes('hoppeborg')) link = '/udlejning/hoppeborg';
    else if (name.toLowerCase().includes('popcorn')) link = '/udlejning/popcorn-maskine';
    else if (name.toLowerCase().includes('slushice')) link = '/udlejning/slushice-maskine';
    else if (name.toLowerCase().includes('soundbox')) link = '/udlejning/soundbox-3';
    else if (name.toLowerCase().includes('stole')) link = '/telt-udlejning/stole';
    else if (name.toLowerCase().includes('firkantede borde')) link = '/telt-udlejning/firkantet-bord';
    else if (name.toLowerCase().includes('runde borde')) link = '/telt-udlejning/runde-bord';
    else if (name.toLowerCase().includes('gulv')) link = '/telt-udlejning/gulv';
    else if (name.toLowerCase().includes('telt')) link = '/telt-udlejning';

    let coverImage = item.cover_image?.[0];
    if (name.toLowerCase().includes('sorte stole')) {
      coverImage = 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image15.jpeg';
    }

    return {
      id: item.id,
      name,
      price,
      category,
      link,
      description: getVal(item.description)?.replace(/<[^>]*>/g, '').substring(0, 80) + '...',
      coverImage
    };
  });

  // Combine static and CMS items
  const allItems = [...mappedCmsItems, ...staticItems];

  // Filter based on active category and search query
  const filteredItems = allItems.filter(item => {
    const matchesCategory = activeCategory === 'alle' || item.category === activeCategory;
    const matchesSearch = item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          item.description?.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const categories = [
    { slug: 'alle', label: 'Alle priser' },
    { slug: 'festudstyr', label: 'Festudstyr & Tilbehør' },
    { slug: 'borde-stole', label: 'Borde & Stole' },
    { slug: 'koel-varme', label: 'Køl & Varme' },
    { slug: 'telte', label: 'Telte & Gulv' },
    { slug: 'maskiner', label: 'Entreprenørmaskiner' }
  ];

  return (
    <div className="flex min-h-screen flex-col bg-stone-50">
      {/* Hero Section */}
      <section className="border-b border-stone-200 bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.35em] text-brand-orange">Prisliste</span>
          <h1 className="mt-3 text-4xl font-semibold text-slate-800 sm:text-5xl">Overskuelig prisliste</h1>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-500 sm:text-base">
            Her finder du en komplet og gennemskuelig oversigt over priserne på vores udlejningsmaskiner, festudstyr og tilbehør.
          </p>
          <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-emerald-50 px-4 py-1.5 text-sm font-semibold text-emerald-700 border border-emerald-100">
            <i className="fa-solid fa-circle-check" />
            <span>Alle priser er inkl. moms</span>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="flex-grow py-12">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          
          {/* Search and Filter Controls */}
          <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            {/* Category Tabs */}
            <div className="flex flex-wrap gap-2">
              {categories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => setActiveCategory(cat.slug)}
                  className={`rounded-full px-4 py-2 text-xs font-bold uppercase tracking-wider transition-colors ${
                    activeCategory === cat.slug
                      ? 'bg-brand-orange text-white'
                      : 'border border-stone-200 bg-white text-slate-600 hover:border-brand-orange hover:text-brand-orange'
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>

            {/* Search Input */}
            <div className="relative w-full md:max-w-xs">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-stone-400">
                <i className="fa-solid fa-magnifying-glass" />
              </span>
              <input
                type="text"
                placeholder="Søg i priser..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full rounded-full border border-stone-200 bg-white py-2 pl-10 pr-4 text-sm text-slate-700 outline-none transition-all focus:border-brand-orange focus:ring-2 focus:ring-brand-orange/20"
              />
            </div>
          </div>

          {/* Table / List */}
          {loading ? (
            <div className="flex justify-center py-20">
              <div className="h-10 w-10 animate-spin rounded-full border-4 border-brand-orange border-t-transparent" />
            </div>
          ) : filteredItems.length === 0 ? (
            <div className="mx-auto max-w-xl rounded-[1.5rem] border border-stone-200 bg-white p-12 text-center">
              <i className="fa-solid fa-magnifying-glass mb-4 text-3xl text-stone-300" />
              <p className="text-slate-500 font-medium">Ingen priser fundet, der matcher din søgning.</p>
            </div>
          ) : (
            <div className="overflow-hidden rounded-[1.5rem] border border-stone-200 bg-white shadow-[0_18px_45px_rgba(148,163,184,0.08)]">
              <div className="overflow-x-auto">
                <table className="w-full border-collapse text-left text-sm text-slate-600">
                  <thead className="border-b border-stone-200 bg-stone-50 text-xs font-bold uppercase tracking-wider text-slate-500">
                    <tr>
                      <th className="px-6 py-4">Udstyr / Tilbehør</th>
                      <th className="px-6 py-4">Kategori</th>
                      <th className="px-6 py-4 text-right">Pris (Inkl. moms)</th>
                      <th className="px-6 py-4 text-right">Handling</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-stone-200">
                    {filteredItems.map((item) => (
                      <tr key={item.id} className="transition-colors hover:bg-stone-50/50">
                        <td className="px-6 py-5 font-semibold text-slate-800">
                          <Link to={item.link} className="flex items-center gap-3 transition-colors hover:text-brand-orange">
                            <img
                              src={
                                item.coverImage
                                  ? (item.coverImage.startsWith('http')
                                      ? (item.coverImage.includes('cdn-cgi') ? item.coverImage : `https://assets.auxodev.dk/cdn-cgi/image/width=100,quality=80,format=auto/${item.coverImage.replace('https://assets.auxodev.dk/', '')}`)
                                      : `https://assets.auxodev.dk/cdn-cgi/image/width=100,quality=80,format=auto/${item.coverImage}`)
                                  : 'https://assets.auxodev.dk/cdn-cgi/image/width=100,quality=80,format=auto/assets/27b85900-9717-41d2-8622-634ea09330b6/image32.jpeg'
                              }
                              alt={item.name}
                              className="h-10 w-16 rounded-lg object-cover bg-stone-100 shrink-0"
                              onError={(e) => {
                                e.target.src = 'https://assets.auxodev.dk/cdn-cgi/image/width=100,quality=80,format=auto/assets/27b85900-9717-41d2-8622-634ea09330b6/image32.jpeg';
                              }}
                            />
                            <div>
                              <span className="block text-slate-800 font-semibold">{item.name}</span>
                              {item.description && (
                                <span className="block text-xs font-normal text-slate-400 line-clamp-1 mt-0.5">
                                  {item.description}
                                </span>
                              )}
                            </div>
                          </Link>
                        </td>
                        <td className="px-6 py-5">
                          <span className="inline-flex items-center gap-1.5 rounded-full border border-stone-200 bg-stone-50 px-2.5 py-1 text-xs font-semibold capitalize text-slate-500">
                            {categories.find(c => c.slug === item.category)?.label || 'Udlejning'}
                          </span>
                        </td>
                        <td className="px-6 py-5 text-right text-base font-bold text-brand-orange whitespace-nowrap">
                          {item.price}
                        </td>
                        <td className="px-6 py-5 text-right">
                          <Link
                            to={item.link}
                            className="inline-flex items-center gap-1.5 rounded-full border border-brand-orange/20 bg-brand-orange/10 px-3 py-2 text-xs font-bold text-brand-orange transition-colors hover:bg-brand-orange hover:text-white"
                          >
                            Book / Læs mere <i className="fa-solid fa-chevron-right text-[10px]" />
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Bottom Info Box */}
          <div className="mx-auto mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
            <div className="flex items-start gap-4 rounded-[1.5rem] border border-brand-orange/10 bg-brand-orange/5 p-6">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-brand-orange/10 text-brand-orange">
                <i className="fa-solid fa-circle-info text-lg" />
              </div>
              <div>
                <h4 className="mb-1 font-semibold text-slate-800">Brug for længerevarende leje?</h4>
                <p className="text-sm leading-relaxed text-slate-500">
                  Hvis du skal bruge en maskine eller udstyr i en længere periode (over 7 dage), tilbyder vi fordelagtige rabatter. Kontakt os direkte for at få et skræddersyet og uforpligtende tilbud.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 rounded-[1.5rem] border border-emerald-500/10 bg-emerald-500/5 p-6">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-emerald-500/10 text-emerald-600">
                <i className="fa-solid fa-percent text-lg" />
              </div>
              <div>
                <h4 className="mb-1 font-semibold text-slate-800">Alle priser er inkl. moms</h4>
                <p className="text-sm leading-relaxed text-slate-500">
                  Hos J F D Service er gennemskuelighed vigtigt. Derfor er alle priser angivet inklusiv 25% dansk moms, så du ikke møder uventede tillæg eller overraskelser.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
